import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source"];
  static values = {
    successMessage: { type: String, default: "Link copied!" },
    errorMessage: { type: String, default: "Failed to copy link." },
    successClass: { type: String, default: "success" },
    errorClass: { type: String, default: "error" },
  };

  connect() {
    console.log("Clipboard controller connected");
  }

  copy(event) {
    event.preventDefault();

    let textToCopy;

    // Check if we have a source target before trying to access it
    if (this.hasSourceTarget) {
      textToCopy = this.sourceTarget.value;
    } else {
      textToCopy = this.element.dataset.clipboardText;
    }

    navigator.clipboard
      .writeText(textToCopy)
      .then(() =>
        this.showToast(this.successMessageValue, this.successClassValue)
      )
      .catch(() =>
        this.showToast(this.errorMessageValue, this.errorClassValue)
      );
  }

  showToast(message, type) {
    const toast = document.createElement("div");
    toast.className = "toast toast-end z-50";
    toast.innerHTML = `
      <div class="alert alert-${type}">
        <span>${message}</span>
      </div>
    `;
    document.body.appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, 3000);
  }
}
